// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeModule_articleTitle__bir3h","row":"noticeModule_row__I91Zi"};